import { SvgIcon, type SvgIconProps } from './svgIcon'

export const DocumentIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.75 2.75H15.6893L19.25 6.31066V21.25H4.75V2.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M7 7.5L13 7.5" stroke="currentColor" strokeWidth="1.5" />
      <line
        x1="7"
        y1="10.25"
        x2="17"
        y2="10.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="7"
        y1="13.25"
        x2="17"
        y2="13.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M7 16.5H12" stroke="currentColor" strokeWidth="1.5" />
      <path d="M15 2V7H20" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  </SvgIcon>
)
